import { Action } from '@ngrx/store';
import {IBackupsSettings} from "../../websites/website/backup/backups-settings.interface";

export const LOAD_BACKUP_SETTINGS = '[Backup] Load Backup Settings';
export const LOAD_BACKUP_SETTINGS_SUCCESS = '[Backup] Load Backup Settings Success';
export const LOAD_BACKUP_SETTINGS_FAIL = '[Backup] Load Backup Settings Fail';

export class LoadBackupSettings implements Action {
  readonly type = LOAD_BACKUP_SETTINGS;
  constructor(public payload: number) {}
}

export class LoadBackupSettingsSuccess implements Action {
  readonly type = LOAD_BACKUP_SETTINGS_SUCCESS;
  constructor(public payload: { websiteId: number; entities: IBackupsSettings }) {}
}

export class LoadBackupSettingsFail implements Action {
  readonly type = LOAD_BACKUP_SETTINGS_FAIL;
  constructor(public payload: { websiteId: number; error: string }) {}
}

export type BackupSettingsAction =
  | LoadBackupSettings
  | LoadBackupSettingsSuccess
  | LoadBackupSettingsFail;

